export default __webpack_public_path__ + "static/media/home.ca2e4e7b.png";